'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectedDroppableDimensionPublisher = require('./connected-droppable-dimension-publisher');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectedDroppableDimensionPublisher).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/droppable-dimension-publisher/index.js
// module id = 537
// module chunks = 0